import { render, staticRenderFns } from "./manageGoods1 copy.vue?vue&type=template&id=66e24c0c&scoped=true&"
import script from "./manageGoods1 copy.vue?vue&type=script&lang=js&"
export * from "./manageGoods1 copy.vue?vue&type=script&lang=js&"
import style0 from "./manageGoods1 copy.vue?vue&type=style&index=0&id=66e24c0c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e24c0c",
  null
  
)

export default component.exports